export default "__VITE_ASSET__EKaMH9lD__"